import { AddressSuggestionsInput, AddressSuggestionType } from '@uplift/types';
import { restClient } from '../client';

export const getAddressSuggestions = async (data: AddressSuggestionsInput) => {
  return restClient.request<AddressSuggestionType[]>('/api/v1/address_verification', {
    method: 'POST',
    data: data,
  });
};
